export const DevURL = "https://api-staging.aequas.sg/api/agency/";
// 3004
// ? Authentication URL
export const JOB_BY_ID ="job_details?job_detail_id="
export const UPDATE_JOBSTATUS ="job_details/updateJob?job_detail_id="
export const RESOLVE_DISPUTE ="dispute_resolution/mark_complete?job_detail_id="
export const DASHBOARD_JOB ="job_details/dashboard"
export const CREATE_JOB = "job_details"
export const GET_ALL_JOB = "job_details/all"